// extracted by mini-css-extract-plugin
export default {"block":"block___PIKhI","resourceName":"resourceName___DCWSM","btn":"btn___oMJvX"};